export const miscConstants = {
	SET_LOADING: 'SET_LOADING',
	SET_ERROR: 'SET_ERROR',
	REMOVE_NOTIFICATIONS: 'REMOVE_NOTIFICATIONS'
}